var React = require('react');

function PlayButtonMeetTeam (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M43.5 87C67.5244 87 87 67.5244 87 43.5C87 19.4756 67.5244 0 43.5 0C19.4756 0 0 19.4756 0 43.5C0 67.5244 19.4756 87 43.5 87ZM60 44L33 28V60L60 44Z","fill":"#fff"}));
}

PlayButtonMeetTeam.defaultProps = {"width":"87","height":"87","viewBox":"0 0 87 87","fill":"none"};

module.exports = PlayButtonMeetTeam;

PlayButtonMeetTeam.default = PlayButtonMeetTeam;
